import PropTypes from 'prop-types';

const inputStyle = {
  fontFamily: 'Source Sans Pro',
  width: '200px',
  height: '40px',
  border: 'none',
  borderRadius: '4px',
  backgroundColor: 'rgba(240, 242, 245, 0.79)',
  outline: 'none',
  paddingLeft: '10px',
  paddingRight: '10px',
  color: '#0f2045',
};

const Input = ({
  label = undefined,
  required = false,
  value = '',
  onChange = () => {},
  onBlur = () => {},
  placeholder = undefined,
  type = 'text',
  error = undefined,
  afterText = undefined,
  maxLength = undefined,
  pattern = undefined,
}) => {
  const className = required ? 'onboarding-label-required' : 'onboarding-label';

  return (
    <div style={{ position: 'relative' }}>
      {label && <p className={className}>{label}</p>}
      <input
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        style={inputStyle}
        type={type}
        maxLength={maxLength}
        pattern={pattern}
      />
      {afterText && <span>{afterText}</span>}
      {error && <p className="onboarding-error">{error}</p>}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  error: PropTypes.string,
  afterText: PropTypes.string,
  maxLength: PropTypes.number,
  pattern: PropTypes.string,
};

export default Input;
